// extracted by mini-css-extract-plugin
export default {"container":"src_container__yFcXH","main":"src_main__NEcuL","content":"src_content__rP35o","contentMain":"src_contentMain__B2TM7"};